import { useEffect } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';

import { ProvedorDeIdentidadeReact, useIdentidade } from './features/autenticacao/ContextoDeIdentidade';
import { ProvedorDeTema } from './tema/ProvedorDeTema';
import { Rotas } from './rotas';
import { criarClienteDeQuery } from './shared/query/clienteDeQuery';
import { useIdentidadeDoShell } from './shared/layout/useIdentidadeDoShell';

const clienteDeQuery = criarClienteDeQuery();

/**
 * Injeta a identidade no shell.
 *
 * `shared/layout` não pode importar `features/autenticacao` (boundaries).
 * Este componente de uma linha é o lugar onde as duas se encontram — o
 * app, que pode conhecer as duas.
 */
export function LigacaoDaIdentidade(): null {
  const { sessao, encerrar } = useIdentidade();
  const definir = useIdentidadeDoShell((estado) => estado.definir);

  useEffect(() => {
    definir({
      nome: sessao?.nome ?? '',
      nucleoId: sessao?.nucleoId ?? null,
      sair: () => {
        // O provedor já zerou a sessão local mesmo se o DELETE falhar; a
        // rejeição não pode virar "unhandled".
        encerrar().catch(() => undefined);
      },
    });
  }, [sessao, encerrar, definir]);

  return null;
}

export function App(): React.JSX.Element {
  return (
    <QueryClientProvider client={clienteDeQuery}>
      <ProvedorDeIdentidadeReact>
        <ProvedorDeTema>
          <BrowserRouter>
            <LigacaoDaIdentidade />
            <Rotas />
          </BrowserRouter>
        </ProvedorDeTema>
      </ProvedorDeIdentidadeReact>
    </QueryClientProvider>
  );
}
